import React, { FC } from 'react';
import styles from './meta-box.module.sass';

export const MetaBoxBody: FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>> = ({
                                                                                                                   className,
                                                                                                                   ...props
                                                                                                                 }) => {
  return <span {...props} className={`${styles.body} ${className ?? ''}`}>{props.children}</span>;
};

export default MetaBoxBody;
